import {Nav, Tab} from 'react-bootstrap'
import {useNavigate, useLocation, Routes, Route} from "react-router-dom";
import {Account} from "./Account";
import {useEffect} from "react";
import {FormikHelpers} from "formik";

export interface AccountsPageProps {
    onConfigSubmit(account: string): (values:any[], actions:FormikHelpers) => Promise<any>,
    configFields: $ObjMap,
    exchangeObj: string,
    setExchangeObj(): any,
    showConfig: boolean,
    setShowConfig(): any,
    exchange: string,
    orderFns: $ObjMap,
    delete(account: string): Promise<any>
}

export const Accounts = (props: AccountsPageProps) => {
    const location = useLocation()
    const exchange = props.exchange
    const accounts = Object.keys(props.exchangeObj)
    const account = location.pathname.split("/")[4]
    const defaultActiveKey = "__" + account
    const navigate = useNavigate();

    const buildUrl = action => `/exchange/${exchange}/accounts/${action}`
    const onTabChange = newValue => {
        let account;
        if (newValue !== '__new') {
            account = newValue.split('__')[1]
        } else {
            account = prompt("Enter account name:")
            props.exchangeObj[account] = {}
            props.setExchangeObj(props.exchangeObj)
            props.setShowConfig(true)
        }

        navigate(buildUrl(account))
    }

    useEffect(() => {
        const firstAccount = Object.keys(props.exchangeObj)[0];
        if (typeof account === 'undefined' && firstAccount) {
            navigate(buildUrl(firstAccount))
        }
    });

    return <Tab.Container id={"exchange"} onSelect={onTabChange}
                          defaultActiveKey={defaultActiveKey} activeKey={defaultActiveKey}>
        <Nav variant="tabs">
            {accounts.map(account => <Nav.Item key={account}>
                <Nav.Link eventKey={`__${account}`}>{account}</Nav.Link>
            </Nav.Item>)}
            <Nav.Item>
                <Nav.Link eventKey="__new">+</Nav.Link>
            </Nav.Item>
        </Nav>
        <Tab.Content>
            <Routes>
                {accounts.map(account =>
                    <Route key={account} path={`/accounts/${account}/*`}
                           element={<Tab.Pane key={account} eventKey={`__${account}`}>
                               <Account account={account} exchange={exchange} onConfigSubmit={props.onConfigSubmit}
                                        configFields={props.configFields} showConfig={props.showConfig[account]}
                                        deleteAccount={props.delete}
                                        exchangeState={props.exchangeObj[account]} orderFns={props.orderFns}/>
                           </Tab.Pane>}/>
                )}
            </Routes>
        </Tab.Content>
    </Tab.Container>;
}
